export type SamplesMaterialsSubTab = 'drops' | 'request' | 'materials';

/**
 * Which sub-tab should be selected when the section first renders for a
 * meeting (and re-validated whenever the active tab stops being visible,
 * e.g. after a format change). Always the first tab that's actually visible,
 * in the same left-to-right order the tab bar itself renders them — Drops,
 * then Materials, then Request (see activities-details-pane.html) — never
 * based on which one happens to have content (OMNI-60544). A tab with zero
 * items but visible still wins over a later tab that has items.
 */
export function resolveDefaultSubTab(visibility: {
  dropsVisible: boolean;
  materialsVisible: boolean;
  requestVisible: boolean;
}): SamplesMaterialsSubTab {
  if (visibility.dropsVisible) return 'drops';
  if (visibility.materialsVisible) return 'materials';
  if (visibility.requestVisible) return 'request';
  return 'drops';
}
